import $ from 'jquery';

window.handleAgentImageError = () => {
    $('.js-agent-image').hide();
    let agentImage = $('.js-agent-image');
    agentImage.addClass('hero-agent-card-image--no-agent-photo');
    $('.hero-agent-card-content-wrapper').addClass('hero-agent-card-content-wrapper--no-agent-photo');
    $('.hero-agent-card-content').addClass('hero-agent-card-content--no-agent-photo');
    $('.hero-agent-card-actions').addClass('hero-agent-card-actions--no-agent-photo');
};